import i18n from 'modules/core/lib/i18n'

export function formatAmount(amountInCents: number, currency: string): string {
  return i18n.formatNumber(amountInCents / 100, 'currency', currency)
}
